import React, { useEffect } from "react";
import { motion } from "framer-motion";
import PrivacyPolicyComponent from "../components/PrivacyPolicy";

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const pageVariants = {
        initial: { opacity: 0, scale: 0.98 },
        in: { opacity: 1, scale: 1 },
        out: { opacity: 0, scale: 1.02 }
    };

    return (
        // <motion.div
        //   initial={{ opacity: 0 }}
        //   animate={{ opacity: 1 }}
        //   exit={{ opacity: 0 }}
        //   transition={{ duration: 0.5 }}
        // >
        //   <AboutComponent />
        // </motion.div>
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={{ duration: 0.5 }}
        >
            <PrivacyPolicy />
        </motion.div>
    );
};

export default PrivacyPolicyComponent;